module.exports = function() {
  return new Worker(__webpack_public_path__ + "f4ef15e0a5a35398fd6b.worker.js");
};